"use strict";
/*******************************************************************************

    Contains definition for error types

    Copyright:
        Copyright (c) 2020-2021 BOSAGORA Foundation
        All rights reserved.

    License:
        MIT License. See LICENSE for details.

*******************************************************************************/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleNetworkError = exports.BadRequestError = exports.NotFoundError = exports.NetworkError = void 0;
/**
 * The class used when a network error occurs
 */
var NetworkError = /** @class */ (function (_super) {
    __extends(NetworkError, _super);
    /**
     * Constructor
     * @param status        The status code
     * @param statusText    The status text
     * @param statusMessage The message of response
     */
    function NetworkError(status, statusText, statusMessage) {
        var _this = _super.call(this, statusText) || this;
        _this.name = "NetworkError";
        _this.status = status;
        _this.statusText = statusText;
        _this.statusMessage = statusMessage;
        return _this;
    }
    return NetworkError;
}(Error));
exports.NetworkError = NetworkError;
/**
 *  When status code is 404
 */
var NotFoundError = /** @class */ (function (_super) {
    __extends(NotFoundError, _super);
    /**
     * Constructor
     * @param status        The status code
     * @param statusText    The status text
     * @param statusMessage The message of response
     */
    function NotFoundError(status, statusText, statusMessage) {
        var _this = _super.call(this, status, statusText, statusMessage) || this;
        _this.name = "NotFoundError";
        return _this;
    }
    return NotFoundError;
}(NetworkError));
exports.NotFoundError = NotFoundError;
/**
 *  When status code is 400
 */
var BadRequestError = /** @class */ (function (_super) {
    __extends(BadRequestError, _super);
    /**
     * Constructor
     * @param status        The status code
     * @param statusText    The status text
     * @param statusMessage The message of response
     */
    function BadRequestError(status, statusText, statusMessage) {
        var _this = _super.call(this, status, statusText, statusMessage) || this;
        _this.name = "BadRequestError";
        return _this;
    }
    return BadRequestError;
}(NetworkError));
exports.BadRequestError = BadRequestError;
/**
 * It is a function that handles errors that occur during communication
 * with a server for easy use.
 * @param error This is why the error occurred
 * @returns The instance of Error
 */
function handleNetworkError(error) {
    if (error.response !== undefined &&
        error.response.status !== undefined &&
        error.response.statusText !== undefined) {
        var statusMessage = void 0;
        if (error.response.data !== undefined) {
            if (typeof error.response.data === "string")
                statusMessage = error.response.data;
            else if (typeof error.response.data === "object" && error.response.data.statusMessage !== undefined)
                statusMessage = error.response.data.statusMessage;
            else if (typeof error.response.data === "object" && error.response.data.errorMessage !== undefined)
                statusMessage = error.response.data.errorMessage;
            else
                statusMessage = error.response.data.toString();
        }
        else
            statusMessage = "";
        switch (error.response.status) {
            case 400:
                return new BadRequestError(error.response.status, error.response.statusText, statusMessage);
            case 404:
                return new NotFoundError(error.response.status, error.response.statusText, statusMessage);
            default:
                return new NetworkError(error.response.status, error.response.statusText, statusMessage);
        }
    }
    else {
        if (error.message !== undefined)
            return new Error(error.message);
        else
            return new Error("An unknown error has occurred.");
    }
}
exports.handleNetworkError = handleNetworkError;
//# sourceMappingURL=ErrorTypes.js.map